export const overloadInterceptor = (error) => {
  return Promise.reject(error);
};
